import { GzPolicyUiSettingsGridWebComponent } from './component/GzPolicyUiSettingsGridWebComponent';

export { GzPolicyUiSettingsGridWebComponent };
